// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/InstagramAccounts_ExchangeTokenInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /instagram/accounts/exchange_token
 *
 * Exchanges OAuth authorization code for Instagram access token.
 */
import { registerContract } from './validate'

export interface InstagramAccounts_ExchangeTokenInput {
code: string
redirect_uri?: string
}

registerContract('InstagramAccounts_ExchangeTokenInput', {
  code:         { type: 'string',  required: true },
  redirect_uri: { type: 'string',  required: false },
})
